module.exports = __webpack_public_path__ + "img/bb_g3_t_antenna-05.e7c37786.svg";